export const BATTERY_LEVELS = [
  'system',
  'array',
  'node',
  'container',
  'bank',
  'pack',
  'module',
  'cell',
] as const;

export type BatteryLevel = (typeof BATTERY_LEVELS)[number];
